import { Blocks, Fingerprint, ShieldCheck, PanelTop, FileCheck2, UserRound, Braces } from 'lucide-react';
import { SectionLabel, SectionConclusion } from './BrandElements';

const APPROACH_HEADING = 'One schema. Every layer.';

const layers = [
  { Icon: Blocks, name: 'Live operational state' },
  { Icon: Fingerprint, name: 'Identity and authorization' },
  { Icon: ShieldCheck, name: 'Policy enforcement' },
  { Icon: PanelTop, name: 'Interfaces and tools' },
  { Icon: FileCheck2, name: 'Verifiable evidence' },
  { Icon: UserRound, name: 'Governed access for people and AI agents' },
];

export const ApproachSection = () => (
  <section className="approach-section section-pad chain-line" id="approach" data-testid="approach-section">
    <div className="container chain-pad">
      <SectionLabel number="02" id="approach" heading={APPROACH_HEADING}>WHAT WE’RE BUILDING</SectionLabel>
      <div className="approach-grid">
        <div className="approach-copy">
          <h3 className="display-heading" data-testid="approach-title">One schema.<br />Every layer.</h3>
          <p className="body-copy" data-testid="approach-description">A shared typed schema defines the system’s objects, the actions available to them, the authority required to act, and the evidence created when state changes.</p>
          <div className="schema-definition" data-testid="schema-definition">
            <div className="schema-definition-title mono"><Braces size={19} aria-hidden="true" /><span data-testid="schema-definition-title">A SHARED TYPED SCHEMA</span><span className="definition-index">01</span></div>
            <dl className="schema-fields mono" data-testid="conceptual-schema-fields"><div><dt>objects</dt><dd>what exists</dd></div><div><dt>actions</dt><dd>what can change</dd></div><div><dt>authority</dt><dd>who can act</dd></div><div><dt>evidence</dt><dd>what supports it</dd></div></dl>
            <p className="mono schema-note" data-testid="schema-concept-note">Conceptual model · not implementation syntax</p>
          </div>
        </div>
        <div className="layer-list" data-testid="schema-layer-list">
          <p className="layer-intro body-copy" data-testid="schema-drives-intro">That schema can drive:</p>
          {layers.map(({ Icon, name }, i) => <div className="layer-row" key={name} data-testid={`schema-layer-${i + 1}`}><Icon className={i === 4 ? 'evidence-icon' : ''} size={21} strokeWidth={1.3} aria-hidden="true" /><h4 data-testid={`layer-${i + 1}-title`}>{name}</h4><span className="mono layer-index">0{i + 1}</span></div>)}
        </div>
      </div>
      <div className="approach-footnote"><SectionConclusion id="approach">There is no separate compliance model to keep synchronized with the real system.</SectionConclusion></div>
    </div>
  </section>
);
